import { IOperationTriggerRow } from 'types/operationTriggers.interface'

export const MOCK_OPERATION_TRIGGERS: IOperationTriggerRow[] = [
  {
    id: 1,
    type: 'Completion',
    title: 'On cycle complete — record handover',
    priority: 'normal',
    siteId: 1,
    departmentId: 1,
    action: 'Create task',
    fireCount: 28,
    lastFired: '8d ago',
    active: true,
  },
  {
    id: 2,
    type: 'Completion',
    title: 'On phase complete — auto-advance plan',
    priority: 'normal',
    siteId: 2,
    departmentId: 3,
    action: 'Create task',
    fireCount: 11,
    lastFired: '8d ago',
    active: true,
  },
  {
    id: 3,
    type: 'Scheduled',
    title: 'Daily 06:00 — start-of-shift walkaround',
    priority: 'normal',
    siteId: 1,
    action: 'Create workflow',
    fireCount: 7,
    lastFired: '8d ago',
    active: true,
  },
  {
    id: 4,
    type: 'Threshold',
    title: 'Conveyor temp ≥ 85°C — raise issue',
    priority: 'high',
    siteId: 1,
    departmentId: 2,
    action: 'Raise issue',
    fireCount: 4,
    lastFired: '8d ago',
    active: true,
  },
  {
    id: 5,
    type: 'Threshold',
    title: 'Pit fatigue index > 0.7 — notify supervisor',
    priority: 'critical',
    siteId: 1,
    departmentId: 4,
    action: 'Notify role',
    fireCount: 2,
    lastFired: '10d ago',
    active: true,
  },
  {
    id: 6,
    type: 'Scheduled',
    title: 'Hourly — refresh queue health',
    priority: 'normal',
    action: 'Notify role',
    fireCount: 0,
    lastFired: null,
    active: false,
  },
]
